import { Table, Tag } from 'antd';
import React from 'react'
import { useNavigate } from 'react-router-dom';

const ContratsTab = ({ contrats, handleChange, filteredInfo, sortedInfo }) => {
    const navigate = useNavigate();

    const columns = [
        {
            title: "N° Police",
            dataIndex: "numeroPolice",
            key: "1",
        },
        {
            title: "Souscripteur",
            dataIndex: "souscripteur",
            key: "2",
        },
        {
            title: "Date Effet",
            dataIndex: "dateEffet",
            key: "4",
        },
        {
            title: "Date Echeance",
            dataIndex: "dateEcheance",
            key: "5",
        },
        {
            title: "Statut reglement",
            dataIndex: "regle",
            key: "regle",
            render: (_, record) => (
                <>
                    {record.regle === "REGLE" ? (
                        <Tag color="success" key={_}>
                            REGLE
                        </Tag>
                    ) : (
                        <Tag color="blue" key={_}>
                            NON REGLE
                        </Tag>
                    )}
                </>
            ),
            filters: [
                {
                    text: "REGLE",
                    value: "REGLE",
                },
                {
                    text: "NON REGLE",
                    value: "NON REGLE",
                },
            ],
            filteredValue: filteredInfo.regle || null,
            onFilter: (value, record) => record.regle === value,
            sorter: (a, b) => a.regle.length - b.regle.length,
            sortOrder: sortedInfo.columnKey === "regle" ? sortedInfo.order : null,
            ellipsis: true,
        },
        {
            title: "Actions",
            dataIndex: "actions",
            key: "7",
            render: (_, record) => (
                <>
                    {record.regle !== "REGLE" && (
                        <button
                            type="button"
                            class="btn btn-success btn-icon rounded-pill"
                            onClick={() => { }}
                        >
                            <i class="bx bxs-credit-card"></i>
                        </button>
                    )}
                    <button
                        type="button"
                        class="btn btn-primary btn-icon rounded-pill"
                        onClick={() => navigate(`/details-contrat/${record.codeId}`)}
                    >
                        <i class="bx bx-dots-vertical-rounded"></i>
                    </button>
                    <button type="button" class="btn btn-danger btn-icon rounded-pill">
                        <i class="bx bxs-file-pdf"></i>
                    </button>
                </>
            ),
        },
    ];

    return (
        <div>
            <Table
                columns={columns}
                dataSource={contrats}
                onChange={handleChange}
            />
        </div>
    )
}

export default ContratsTab